import makeStyles from '@material-ui/core/styles/makeStyles';
import { ISpcTheme } from '../../../theme/ISpcTheme';

const postcodeFormStyles = makeStyles<ISpcTheme>(theme => ({
  formContainer: {
    minHeight: '7.6rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '2rem',
    },
  },
  submit: {
    flexShrink: 100,
    padding: '1rem 2rem',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    minWidth: 65,
    minHeight: '5.5rem',
    borderRadius: '0.5rem',
    marginLeft: '1rem',
    '&:disabled': {
      backgroundColor: theme.palette.text.secondary,
      color: theme.palette.common.white,
    },
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      '@media (hover: none)': {
        backgroundColor: theme.palette.primary.main,
        '&:active': {
          backgroundColor: theme.palette.secondary.main,
        },
      },
    },
  },
  submitMobile: {
    marginLeft: '0.5rem',
    minWidth: 50,
  },
  searchField: {
    // Fix for IOS Safari zooming in when field focused.
    '&:not(.any) input': {
      fontSize: theme.typography.pxToRem(theme.typography.fontMD),
      borderRadius: 0,
    },
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
  },
}));

export default postcodeFormStyles;
